/*
  Taggfilter uten hopp til toppen. Bygget 16. september 2026.
  Klikk på en tagg i oversikten henter den filtrerte siden i bakgrunnen og bytter
  ut filterrad og rutenett på stedet. Adressen oppdateres (/blogs/blog/tagged/...),
  så lenken kan deles og tilbake-knappen virker. Scrollposisjonen blir stående.
  Uten JavaScript, eller hvis hentingen feiler, går lenken som vanlig.
*/
(function () {
  var root = document.querySelector('[data-blog-filter-root]');
  if (!root || !window.fetch || !window.DOMParser || !history.pushState) return;

  var loading = false;

  function load(url, push, focusHref) {
    if (loading) return;
    loading = true;
    root.setAttribute('aria-busy', 'true');
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('status');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-blog-filter-root]');
        if (!next) throw new Error('root');
        root.innerHTML = next.innerHTML;
        if (doc.title) document.title = doc.title;
        if (push) history.pushState({ blogFilter: true }, '', url);
        var target = root.querySelector('.mb-filter .is-active') || root.querySelector('.mb-filter .mb-tag');
        if (target && target.focus) {
          try { target.focus({ preventScroll: true }); } catch (e) {}
        }
      })
      .catch(function () {
        window.location.href = url;
      })
      .then(function () {
        loading = false;
        root.removeAttribute('aria-busy');
      });
  }

  root.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a.mb-tag') : null;
    if (!link || !root.contains(link)) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (link.origin !== window.location.origin) return;
    e.preventDefault();
    load(link.href, true);
  });

  window.addEventListener('popstate', function () {
    load(window.location.href, false);
  });
})();
